export default "__VITE_PUBLIC_ASSET__2b15cbeb__"